import styles from "./closeButton.module.scss";

interface IProps {
  onClick?: () => void;
  label?: string;
  showWhite?: boolean;
  className?: string;
}

function CloseButton(props: IProps) {
  const {
    label, onClick, showWhite = false, className = "",
  } = props;
  return (
    <>
      <button
        type="button"
        className={`${styles.close_button} ${className}`}
        onClick={onClick}
        aria-label={label || "Close"}
        data-testid="modal-close-button"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 36 36" fill="none">
          <line x1="11" y1="11" x2="25" y2="25" stroke={showWhite ? "#ffffff" : "#000000"} strokeWidth="1.5" strokeLinecap="round" />
          <line x1="25" y1="11" x2="11" y2="25" stroke={showWhite ? "#ffffff" : "#000000"} strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>

      <span className="sr-only">{label}</span>
    </>
  );
}

export default CloseButton;
